import type { Subscription } from '../../types';
import { getSeatLimit as getLegacySubscriptionSeatLimit } from '../legacySubscription/getSeatLimit';
import { getSeatLimit as getModernSubscriptionSeatLimit } from '../modernSubscription/getSeatLimit';

import { isModernSubscription } from './isModernSubscription';

export function getSeatLimit(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return getModernSubscriptionSeatLimit(subscription);
  }

  return getLegacySubscriptionSeatLimit(subscription);
}
